<div>
    <div class="spinner-loading"><span class="spinner-border" role="status"></span></div>
</div>
